import { SalaryIncludes } from './salary-incluce.interface';
import { SalaryIncludeService } from './salary-include.service';

const service = new SalaryIncludeService();

export interface SalaryIncludeState {
   salaryIncludes: Array<SalaryIncludes>;
}

const state: SalaryIncludeState = {
   salaryIncludes: [],
};

const getters = {
   salaryIncludes(state: SalaryIncludeState) {
      return state.salaryIncludes;
   },
};

const mutations = {
   SET_SALARY_INCLUDES(state: SalaryIncludeState, salaryIncludes: Array<SalaryIncludes>) {
      return (state.salaryIncludes = salaryIncludes);
   },
};

const actions = {
   async getSalaryIncludes(context: any, query: any) {
      return service.getSalaryIncludes(query).then((response) => {
         context.commit('SET_SALARY_INCLUDES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,

   state,
   getters,
   mutations,
   actions,
};
